if (!customElements.get('product-proof-slider')) {
  customElements.define(
    'product-proof-slider',
    class ProductProofSlider extends HTMLElement {
      constructor() {
        super();
        this.list = this.querySelector('.product-proof__stats');
        this.items = Array.from(this.querySelectorAll('.product-proof__stat'));
        this.dots = Array.from(this.querySelectorAll('.product-proof__dot'));

        if (!this.list || this.items.length === 0) return;

        this.isDown = false;
        this.dragged = false;
        this.startX = 0;
        this.scrollLeftStart = 0;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.list.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        this.list.addEventListener('click', this.onClickCapture, true);
        this.list.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });

        this.onScroll();
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse') return;
        this.isDown = true;
        this.dragged = false;
        this.startX = event.clientX;
        this.scrollLeftStart = this.list.scrollLeft;
        this.list.classList.add('is-dragging');
      }

      onPointerMove(event) {
        if (!this.isDown) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 5) this.dragged = true;
        this.list.scrollLeft = this.scrollLeftStart - delta;
      }

      onPointerUp() {
        if (!this.isDown) return;
        this.isDown = false;
        this.list.classList.remove('is-dragging');
        // Allow the click suppression to run before it's reset.
        requestAnimationFrame(() => {
          this.dragged = false;
        });
      }

      onClickCapture(event) {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
        }
      }

      onScroll() {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => {
          this.updateActiveDot();
        }, 100);
      }

      updateActiveDot() {
        if (this.dots.length === 0) return;
        const center = this.list.scrollLeft + this.list.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === closestIndex);
        });
      }

      goToSlide(index) {
        const item = this.items[index];
        if (!item) return;
        const target = item.offsetLeft - (this.list.clientWidth - item.offsetWidth) / 2;
        this.list.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
  );
}
